import { render, staticRenderFns } from "./TheDocumentNotes.vue?vue&type=template&id=0ac83958&scoped=true&"
import script from "./TheDocumentNotes.vue?vue&type=script&lang=js&"
export * from "./TheDocumentNotes.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentNotes.vue?vue&type=style&index=0&id=0ac83958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac83958",
  null
  
)

export default component.exports